import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/web/app/(marketing)/tools/json-parser/page-client.tsx");
